import { makeStyles } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import LinkExternal from '../../../../assets/svg/link-external.svg'

export function CustomLink({
    name,
    path,
    isReactRouterLink = true,
    isMobile = false,
    onMobilePress
}) {
    const classes = useStyles()
    return (
        <div className={classes.linkWrapper}>
            {isMobile ? (
                <>
                    <div
                        className={classes.link}
                        style={{ color: 'black' }}
                        onClick={onMobilePress}
                    >
                        {name}{' '}
                        <img
                            className={classes.icon}
                            src={LinkExternal}
                            alt="external-link"
                        />
                    </div>
                </>
            ) : (
                <>
                    {isReactRouterLink ? (
                        <>
                            <Link
                                className={classes.link}
                                style={{ color: 'black' }}
                                to={path}
                                target="_blank"
                            >
                                {name}
                                <img
                                    className={classes.icon}
                                    src={LinkExternal}
                                    alt="external-link"
                                />
                            </Link>
                        </>
                    ) : (
                        <>
                            <a
                                className={classes.link}
                                style={{ color: 'black' }}
                                href={path}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {name}{' '}
                                <img
                                    className={classes.icon}
                                    src={LinkExternal}
                                    alt="external-link"
                                />
                            </a>
                        </>
                    )}
                </>
            )}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    linkWrapper: {
        display: 'flex',
        height: '14px',
        alignItems: 'center',
        color: theme.primary
    },
    link: {
        display: 'flex',
        height: '14px',
        alignItems: 'center',
        textDecoration: 'none',
        font: '14px',
        fontWeight: 700,
        gap: '2px',
        '&:hover': {
            textDecoration: 'underline'
        },
        marginRight: '3px'
    },
    icon: {
        height: '100%'
    }
}))
